import { defineMessages, useIntl } from 'react-intl'
import LogoSaunaria from 'assets/images/logos/Saunaria.svg'
import SaunariaPicture1 from 'assets/images/zones/saunaria/saunaria_view_1.png'
import SaunariaPicture2 from 'assets/images/zones/saunaria/saunaria_view_2.png'
import SaunariaPicture3 from 'assets/images/zones/saunaria/saunaria_view_3.png'
import SaunariaPicture4 from 'assets/images/zones/saunaria/saunaria_view_4.png'
import SaunariaPicture5 from 'assets/images/zones/saunaria/saunaria_view_5.png'
import ZonesModalCategory, {
    BulletsMessages,
} from 'routes/Tickets/sections/ZonesDescription/components/ZonesModal/components/ZonesModalCategory'

const ZonesCategorySaunaria = () => {
    const { formatMessage } = useIntl()

    const name = formatMessage({
        id: 'zones.modal.saunaria_name',
        defaultMessage: 'Saunaria',
    })
    const description = formatMessage({
        id: 'zones.modal.saunaria_description',
        defaultMessage: 'Relaks w saunach z całego świata',
    })
    const bullets: BulletsMessages = defineMessages({
        pt0: {
            id: 'zones.modal.saunaria_bullet_1',
            defaultMessage: 'Wstęp do stref Jamango i Relax',
        },
        pt1: {
            id: 'zones.modal.saunaria_bullet_2',
            defaultMessage: '5 saun mokrych',
        },
        pt2: {
            id: 'zones.modal.saunaria_bullet_3',
            defaultMessage: '10 saun suchych',
        },
        pt3: {
            id: 'zones.modal.saunaria_bullet_4',
            defaultMessage: '2 jacuzzi',
        },
        pt4: {
            id: 'zones.modal.saunaria_bullet_5',
            defaultMessage: 'Pokazy saunamistrzów',
        },
    })

    const images = [
        SaunariaPicture1,
        SaunariaPicture2,
        SaunariaPicture3,
        SaunariaPicture4,
        SaunariaPicture5,
    ]

    return (
        <ZonesModalCategory
            iconUrl={LogoSaunaria}
            zoneName={name}
            hasAgeBadge
            shortDescription={description}
            bullets={bullets}
            images={images}
        />
    )
}

export default ZonesCategorySaunaria
